/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';

import { ErrorIcon, FavoriteIcon, Tag, TagLockIcon, TagShareIcon } from '@utilities';

import NarrativeStatus from '../../../../../components/NarrativeStatus';

import workspaceStyles from '../../../_index.module.scss';

const getNarrativeDestination = ({ canOpenDynamicNarrativesInCanvas = false, narrative = {} }) => {
  const shouldOpenInCanvas =
    canOpenDynamicNarrativesInCanvas &&
    narrative?.isOwner &&
    narrative?.narrativeId === 'dynamic' &&
    narrative?.sessionId;

  if (shouldOpenInCanvas) {
    return {
      state: undefined,
      to: `/dashboard/narratives?sessionId=${narrative.sessionId}&narrativeId=${narrative.id}`,
    };
  }

  return {
    state: undefined,
    to: `/dashboard/narrative/${narrative?.id}`,
  };
};

export const getItemColumns = ({ canOpenDynamicNarrativesInCanvas = false } = {}) => [
  {
    accessor: 'name',
    Cell: ({ row }) => {
      const destination = getNarrativeDestination({
        canOpenDynamicNarrativesInCanvas,
        narrative: row?.original,
      });

      return (
        <Link state={destination.state} to={destination.to}>
          {row?.original?.name}
        </Link>
      );
    },
    Header: 'Name',
    width: 225,
  },
  {
    accessor: 'type',
    Cell: ({ row }) => {
      return <span title={row?.original?.narrativeName}>{row?.original?.narrativeName}</span>;
    },
    Header: 'Type',
    width: 100,
  },
  {
    accessor: 'status',
    Cell: ({ row }) => {
      return <NarrativeStatus narrative={row?.original} showCompleteMessage showTruncatedMessage />;
    },
    disableSortBy: true,
    Header: 'Status',
    width: 100,
  },
  {
    Cell: ({ row }) => {
      return (
        <span className={workspaceStyles['workspace-tags-cell']}>
          {row?.original?.isShared && <Tag icon={<TagShareIcon />} tooltip="Shared" />}
          {row?.original?.isFavorite && <Tag icon={<FavoriteIcon />} tooltip="Favorite" />}
          {!row?.original?.isOwner && <Tag icon={<TagLockIcon />} tooltip="Locked" />}
          {row?.original?.hasException && <Tag icon={<ErrorIcon />} tooltip="Failed" />}
        </span>
      );
    },
    disableSortBy: true,
    Header: 'Tags',
    width: 100,
  },
  {
    accessor: 'creator',
    Header: 'Creator',
    width: 100,
  },
  {
    accessor: 'created_datetime',
    Cell: ({ row }) => {
      return new Date(row?.original?.createdDateTime).toLocaleDateString('en-us', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    },
    Header: 'Created',
    width: 100,
  },
];

export const FILTER_OPTIONS = [
  {
    label: 'Creator',
    options: [
      {
        label: 'Created by Me',
        value: 'created_by_me_all',
      },
      {
        label: 'Created by Others',
        value: 'created_by_others_all',
      },
    ],
  },
  {
    label: 'Narratives',
    options: [
      {
        label: 'Shared Narrative',
        value: 'is_shared_item',
      },
      {
        label: 'Favorite Narrative',
        value: 'is_favorite_item',
      },
    ],
  },
];
